var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Top"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "margin-top-75" }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v(
                  "\n          En text kunde inte laddas in från vårat innehållshanteringssystem, vi ber om ursäkt för besväret.\n          Var vänlig "
                ),
                _c("router-link", { attrs: { to: "/faq/contact" } }, [
                  _vm._v("kontakta supporten")
                ]),
                _vm._v(".\n        ")
              ],
              1
            ),
            _vm._v(" "),
            _vm.err
              ? _c("div", [
                  _c("p", [_vm._v("Felmeddelande:")]),
                  _c("pre", { staticClass: "pre" }, [_vm._v(_vm._s(_vm.err))])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "clearfix--min" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-lg btn-block",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/")
                  }
                }
              },
              [_vm._v("Till startsidan")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm" })
        ])
      ]),
      _vm._v(" "),
      _c("Bottom")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-wrapper" }, [
      _c("h1", { staticClass: "text-danger left-header" }, [
        _vm._v("Ett fel har inträffat!")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12d8a501", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d8a501","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorContent.vue
// module id = null
// module chunks = 